'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/Smiley.js";
var f = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var t = (m, e, o) => e in m ? f(m, e, { enumerable: true, configurable: true, writable: true, value: o }) : m[e] = o, a = (m, e) => {
  for (var o in e || (e = {}))
    c.call(e, o) && t(m, o, e[o]);
  if (r)
    for (var o of r(e))
      l.call(e, o) && t(m, o, e[o]);
  return m;
}, i = (m, e) => p(m, s(e));
const I = forwardRef((m, e) => /* @__PURE__ */ a__default.createElement(b, i(a({ ref: e }, m), { weights: t$1 })));
I.displayName = "Smiley";
export {
  I as Smiley
};
